import React, { useState, useEffect } from "react";

import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import { Grid, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";

import { NavBar } from "./NavBar";
import Settings from "./Settings";
import Dashboard from "./Dashboard";
import useStyles from "./Styles/ProfileStyles";
import TeamFundraisers from "./TeamFundraisers";
import DonationHistory from "./DonationHistory";
import { Footer, Header } from "../../components";
import { profileActions } from "../../store/actions";
import PersonalFundraisers from "./PersonalFundraiser";
import Tracking from "../../services/tracking.service";
import { PAGENAME_CONSTANTS, PROFILE_TABS } from "../../constants";

export function Profile() {
    const classes = useStyles();
    const dispatch = useDispatch();
    const user = useSelector(state => state.authentication.current_user);

    const { DASHBOARD, TEAM_PAGES, USER_PAGES, DONATION_HISTORY, SETTINGS } = PROFILE_TABS

    const initialTabValue = window.location.search ? parseInt(window.location.search.split("=")[1]) : DASHBOARD;
    const [selectedTab, setSelectedTab] = useState(initialTabValue);

    useEffect(() => {

        Tracking.trackPage({ pageName: PAGENAME_CONSTANTS.PROFILE })
        if (!user) dispatch(profileActions.fetchUserData());
    }, [])
    
    useEffect(() => {
        switch (selectedTab) {

            case DASHBOARD:
                Tracking.trackPage({ pageName: PAGENAME_CONSTANTS.DASHBOARD });
                break;

            case TEAM_PAGES:
                Tracking.trackPage({ pageName: PAGENAME_CONSTANTS.TEAM_FUNDRAISERS });
                break;

            case USER_PAGES:
                Tracking.trackPage({ pageName: PAGENAME_CONSTANTS.PERSONAL_FUNDRAISERS });
                break;

            case DONATION_HISTORY:
                Tracking.trackPage({ pageName: PAGENAME_CONSTANTS.DONATION_HISTORY });
                break;

            case SETTINGS:
                Tracking.trackPage({ pageName: PAGENAME_CONSTANTS.SETTINGS });
                break;

            default:
                break;
        }
    }, [selectedTab])

    const renderAndTrackSelectedTab = () => {
        switch (selectedTab) {
            case DASHBOARD:
                window.history.replaceState({}, 'profilePage', `profile?tab=${DASHBOARD}`);
                return <Dashboard />

            case TEAM_PAGES:
                window.history.replaceState({}, 'profilePage', `profile?tab=${TEAM_PAGES}`);
                return <TeamFundraisers />

            case USER_PAGES:
                window.history.replaceState({}, 'profilePage', `profile?tab=${USER_PAGES}`);
                return <PersonalFundraisers />

            case DONATION_HISTORY:
                window.history.replaceState({}, 'profilePage', `profile?tab=${DONATION_HISTORY}`);
                return <DonationHistory />

            case SETTINGS:
                window.history.replaceState({}, 'profilePage', `profile?tab=${SETTINGS}`);
                return <Settings />

            default:
                return null;
        }
    }

    return <React.Fragment>
        <Header />
        <Container fixed component="main" className={`${classes.root} App-content`}>
            <Box>
                {user && <Typography className={classes.welcomeText}>Welcome back, {user.name}!</Typography>}
                <Typography>Thank you for being a part of the global TCF family!</Typography>
            </Box>
            <Grid container sx={{ mt: '15px' }} spacing={4}>
                <Grid item md={3} sm={12} xs={12}>
                    <NavBar selectedTab={selectedTab} setSelectedTab={setSelectedTab} />
                </Grid>
                <Grid item md={9} sm={12} xs={12}>
                    {renderAndTrackSelectedTab()}
                </Grid>
            </Grid>
        </Container>
        <Footer />
    </React.Fragment>
}